module.exports = __webpack_public_path__ + "static/media/nr.a00df6c7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/nr.svg
// module id = 1001
// module chunks = 0